@if (loading) {
  <div class="flex justify-center">
    <p-progressSpinner></p-progressSpinner>
  </div>
} @else {
  <label class="label">Second Level Routing:</label>
  <div class="p-field-value">
    <p-select
      optionLabel="description"
      [options]="secondLevelRoutingData"
      [(ngModel)]="selectedRoutingOption"
      [filterBy]="'description'"
      filter="true"
      filterPlaceholder="Search"
      placeholder="Select"
      appendTo="body"
      styleClass="w-full mt-1"
    ></p-select>
  </div>
  <div class="flex justify-end mt-4">
    <button
      type="button"
      pButton
      label="Cancel"
      class="p-button-secondary mr-2"
      (click)="onCancel()"
    ></button>
    <button
      type="button"
      pButton
      label="Route"
      [disabled]="!selectedRoutingOption"
      (click)="onRoute()"
      >
    </button>
  </div>
}

